// Constants shared across landing components

export const WHATSAPP_PALERMO = "5491162200025";
export const WHATSAPP_NUNEZ = "5491167480818";
export const WHATSAPP_DEFAULT = WHATSAPP_PALERMO; // for top-level CTAs (Palermo is the central one)

// Real interior photos provided by the owner
export const IMG = {
  // Bar with BODEGON NUÑEZ stencil & mezzanine — best as hero
  heroBg:
    "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/nr5s5qr0_SaveClip.App_471414896_18433302376078585_8214470833029512387_n.jpg",
  // Tables with checkered tablecloth + Pietro Sorba chalkboard quote
  about:
    "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/lrstw2j4_SaveClip.App_471765934_18433302046078585_7806003138615180400_n.jpg",
  // Gallery
  g1: "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/up4tjv9m_SaveClip.App_471818174_18433302289078585_5644492149995823659_n.jpg",
  g2: "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/lrstw2j4_SaveClip.App_471765934_18433302046078585_7806003138615180400_n.jpg",
  g3: "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/e8nzsoq2_SaveClip.App_465084294_18422988517078585_596900264805403389_n.jpg",
  g4: "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/9odo1jxc_SaveClip.App_464980374_18422988508078585_3305428883115805032_n.jpg",
  g5: "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/nr5s5qr0_SaveClip.App_471414896_18433302376078585_8214470833029512387_n.jpg",
  g6: "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/up4tjv9m_SaveClip.App_471818174_18433302289078585_5644492149995823659_n.jpg",
  facadePalermo:
    "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/nr5s5qr0_SaveClip.App_471414896_18433302376078585_8214470833029512387_n.jpg",
  facadeNunez:
    "https://customer-assets.emergentagent.com/job_milanesa-gigante/artifacts/e8nzsoq2_SaveClip.App_465084294_18422988517078585_596900264805403389_n.jpg",
};
